module.exports = __webpack_public_path__ + "img/3-2_Data_Registration_Flow.7a2a8a0c.png";